import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import g from 'src/constants/global';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';

const HeadC = dynamic(() => import('src/components/Head'));
const FasilitasKesehatanContainer = dynamic(() => import('src/containers/FasilitasKesehatan'));

const FasilitasKesehatan = () => {
	return (
		<>
			<HeadC
				title="Kerja Sama Fasilitas Kesehatan di KlikDokter"
				description={
					'Mari bersinergi dan menjadi Mitra Fasilitas Kesehatan KlikDokter. ' +
					'Ajukan kerja sama Faskes Rumah Sakit, Laboratorium, Klinik, dan Apotek di sini. '
				}
			/>
			<FasilitasKesehatanContainer />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	return {
		props: {},
		revalidate: g.REVALIDATE_EXP_ARTICLE,
	};
});

export default FasilitasKesehatan;
